import Collapsible from 'src/javascripts/components/utilities/Collapsible';
import TooltipInit from 'src/javascripts/components/utilities/TooltipInit';
import AdminHistoricalChart from 'src/javascripts/components/charts/AdminHistoricalChart';
import NavbarNotifications from 'src/javascripts/components/notifications/NavbarNotifications';
import ImagePicker from 'src/javascripts/components/forms/ImagePicker';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import 'summernote/dist/summernote-bs4.min.js'
import * as filestack from 'filestack-js';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

export default class Admin {

  constructor() {}

  render() {

    // If setting up an account
    // Poll for setup status
    let setupStatusPoll = () => {
      let accountUrl = $('#accountSetup').attr('data-account-url');
      let url = '/' + accountUrl + '/setup.js';

      // Execute ajax request
      $.ajax({
        type: "GET",
        dataType: "script",
        timeout: 2000,
        url: url,
        complete() {
          setTimeout(function() { setupStatusPoll() }, 2000);
        }
      });

    };

    // Poll server for status of account setup
    if ($('#accountSetup').length > 0) {
      setupStatusPoll();
    }

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = window.location.href.split('?')[0];
      let params = {};
      let status = $('#admin_table').attr('data-filters-status');
      if (typeof status !== 'undefined') {params['status'] = status.toLowerCase()}
      Turbo.visit(url + '?' + $.param(params));
    }

    // On filter select
    $('#search_status').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      $('.tooltip').tooltip('hide');
      $('#admin_table').attr('data-filters-status', suggestion);
      reloadWithSelectedParams();
      $(this).blur();
    });

    // Subscription update for accounts
    if ($('#account_subscription_attributes__destroy').length !== 0) {
      $('#account_subscription_attributes_plan_id').change(function() {
        let val = $(this).val();
        if (val.length > 0) {
          $('#account_subscription_attributes__destroy').val(false);
        } else {
          $('#account_subscription_attributes__destroy').val(true);
        }
      });
    }

    // Enable products or features on change
    $('.enabled-feature-input, .enabled-product-input').change(function() {
      let hiddenInput = $(this).closest('.custom-control').find('.hidden-destroy');
      if ($(this).is(':checked')) {
        hiddenInput.val('false');
      } else {
        hiddenInput.val('true');
      }
    })

    // Image picker
    if ($('.filepicker').length !== 0) {
      ImagePicker();

      // On show modal
      $('.show-images-modal').click(function () {
        let fieldGroupId = $(this).attr('data-field-group-id');
        $('#imagesModal').find('.select-image').attr('data-field-group-id', fieldGroupId);
      });

      // Apply selected image on click
      $('.select-image').click(function() {
        // Update hidden field
        let url = $('.uploaded-image-container.active').attr('data-image-url');
        let fieldGroupId = $(this).attr('data-field-group-id');
        $('#' + fieldGroupId).find('input[type=\'hidden\']').val(url);

        // Close modal
        $('#imagesModal').modal('hide');

        // Append image
        let src = $('.uploaded-image-container.active').find('img').attr('src');
        let image = "<img src=\'" + src + " \' class=\'img-fluid\'>";
        $('#' + fieldGroupId).find('.applied-image-container').empty().append(image);

      })

    }

  	// Initiate admin historical charts
  	$('.admin-historical-chart').each(function() {

  		// Return if already has c3-data (already initialized)
  		// Needed to prevent re-init when navigating away from page, before new body has loaded
  		if (typeof $(this).data('c3-chart') === 'undefined') { 

  			let chartId = $(this).attr('id');
  			let chart = new AdminHistoricalChart($('#' + chartId));

  			// Get data, render chart, set up chart, and create connected table, if exists
  			return $.when(chart.getData())
  			 .then( data => chart.render(data))
  			 .then( chartObj => chart.setUp(chartObj));

  		}

  	});

    // Filter by country, etc.
    if ($('.accounts-master-view-filter').length !== 0) {
      $('.accounts-master-view-filter').change(function() {
        let country = $('#countrySelect').val();
        let accountType = $('#accountTypeSelect').val();
        let paymentStatus = $('#paymentStatusSelect').val();
        let baseUrl = window.location.pathname;
        let params = {};
        if (country != 'All countries') { params['country'] = country; }
        if (accountType != 'All account types') { params['account_type'] = accountType; }
        if (paymentStatus != 'All statuses') { params['payment_status'] = paymentStatus; }
        let url;
        url = baseUrl + '?' + $.param(params);
        Turbo.visit(url);
      })
    }


    // Summernote text editor (currently only used in admin)
    if ($('.summernote').length !== 0) {

      // Send file to AWS
      // https://stackoverflow.com/questions/11240127/uploading-image-to-amazon-s3-with-html-javascript-jquery-with-ajax-request-n
      let sendFile = function(file) {
        let formData      = new FormData();
        let fileInput     = $('.summernote');
        let env           = fileInput.data("env");
        let accountUrl       = fileInput.data("account-url");
        formData.append("key", fileInput.data('form-data')["key"]);
        formData.append("success_action_status", fileInput.data('form-data')["success_action_status"]);
        formData.append("acl", "private");
        formData.append("policy", fileInput.data('form-data')["policy"]);
        formData.append("x-amz-algorithm", fileInput.data('form-data')["x-amz-algorithm"]);
        formData.append("x-amz-credential", fileInput.data('form-data')["x-amz-credential"]);
        formData.append("x-amz-date", fileInput.data('form-data')["x-amz-date"]);
        formData.append("x-amz-signature", fileInput.data('form-data')["x-amz-signature"]);
        formData.append("file", file);
        formData.append('Content-Type', file.type);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', fileInput.data('url'), true); //MUST BE LAST LINE BEFORE YOU SEND 
        xhr.send(formData);
        return file.name;
      };

      $('.summernote').summernote({
        minHeight: 300,
        codeviewFilter: false,         // Disable filtering in code view
        codeviewIframeFilter: false,   // Allow <iframe> tags in code view
        toolbar: [
          ['font', ['bold', 'italic', 'underline', 'clear']],
          ['para', ['ul']],
          ['insert', ['link', 'picture']],
          ['view', ['fullscreen', 'codeview']],
        ],
        callbacks: {      
          onImageUpload: function(files, editor, welEditable) {
            $.when( sendFile(files[0]) ).then(function(name) {
              let key = $('.summernote').data('form-data')["key"];
              name = name.replace(/ /g, '+');
              key = key.replace("${filename}", name);
              let cloudFront = $('.summernote').data("cloudfront-url");
              let url = "https://" + cloudFront + '/' + key;
              let div = "<div class=\'mb-3 border-dark shadow\' style=\'width: 600px;\'>"; 
              div += "<a href=\'" + url + "\' target=\'_blank\'>";
              div += "<img width=600 filename=\'" + name + "\' src=\'" + url + "\'></img>";
              div += "</a></div>";
              return $('.summernote').summernote('pasteHTML', div);
            });
          }
        }
      });

    }

    // Plan type
    if ($('.select-plan-type').length !== 0) {
      $('.select-plan-type').change(function() {
        if ($(this).val() === "base") {
          $('.base-fields').removeClass('d-none');
        } else {
          $('.base-fields').addClass('d-none');
        }
      })
    }


    // If docs upload
    if ($('.product-document-filepicker').length !== 0) {
      $('.product-document-filepicker').each(function(i, elem) {
        let fileInput     = $(elem);
        let filePicker    = $(this);
        let env           = fileInput.data("env");
        let primaryColor  = fileInput.data("primary-color");
        var progressBar   = $("<div class='bar'></div>");
        var barContainer  = $("<div class='progress'></div>").append(progressBar);
        $('#fileUploadProgress').append(barContainer);
        fileInput.fileupload({
          fileInput:        fileInput,
          url:              fileInput.data('url'),
          type:             'POST',
          autoUpload:       true,
          formData:         fileInput.data('form-data'),
          paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
          dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
          replaceFileInput: false,
          progressall: function (e, data) {
            var progress = parseInt(data.loaded / data.total * 100, 10);
            progressBar.css('width', progress + '%')
          },
          start: function (e) {
            progressBar.
              css('background', primaryColor).
              css('display', 'block').
              css('width', '0%').
              css("height", "25px");
          },
          done: function(e, data) {
            progressBar.text("");

            // extract key from product
            let key = $(data.jqXHR.responseXML).find("Key").text();
            let docName = $('#document_name').val();
            let productId = filePicker.attr('data-product-id');

            // Set spinner so user knows in progress
            $(this).closest('.filepicker-container .filepicker-label').addClass('opaque');
            Spinner($(this).closest('.filepicker-container'));

            // Upload file
            let url = '/admin/products/' + productId + '/documents.json';
            let formData = {}
            formData['file'] = {}
            formData['file']['key'] = key;
            formData['file']['name'] = docName;

            // Update local attribute
            return $.ajax({
              type: 'POST',
              url: url,
              dataType: "application/json",
              data: formData,
              complete(result) { 
                let url;
                let productId = filePicker.attr('data-product-id');
                let params = {};

                // Set open elements
                let openEls = [];
                $('div[aria-expanded=\'true\']').each(function() {
                  let controls = $(this).attr('aria-controls');
                  openEls.push(controls);
                });
                params['openElements'] = openEls;
                $('#product_documents_table').DataTable().ajax.reload();
                $('#addDocModal').modal('hide');
              },
            });
          },
          fail: function(e, data) {
            progressBar.
              css("background", "red").
              text("Failed");
          }
        });
      });
    }

    // If images upload
    if ($('.product-image-filepicker').length !== 0) {
      $('.product-image-filepicker').each(function(i, elem) {
        let fileInput     = $(elem);
        let filePicker    = $(this);
        let env           = fileInput.data("env");
        let primaryColor  = fileInput.data("primary-color");
        var progressBar   = $("<div class='bar'></div>");
        var barContainer  = $("<div class='progress'></div>").append(progressBar);
        $('#fileUploadProgress').append(barContainer);
        fileInput.fileupload({
          fileInput:        fileInput,
          url:              fileInput.data('url'),
          type:             'POST',
          autoUpload:       true,
          formData:         fileInput.data('form-data'),
          paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
          dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
          replaceFileInput: false,
          progressall: function (e, data) {
            var progress = parseInt(data.loaded / data.total * 100, 10);
            progressBar.css('width', progress + '%')
          },
          start: function (e) {
            progressBar.
              css('background', primaryColor).
              css('display', 'block').
              css('width', '0%').
              css("height", "25px");
          },
          done: function(e, data) {
            progressBar.text("");

            // extract key from product
            let key = $(data.jqXHR.responseXML).find("Key").text();
            let productId = filePicker.attr('data-product-id');

            // Set spinner so user knows in progress
            $(this).closest('.filepicker-container .filepicker-label').addClass('opaque');
            Spinner($(this).closest('.filepicker-container'));

            // Upload file
            let url = '/admin/products/' + productId + '/images.json';
            let formData = {}
            formData['image'] = {}
            formData['image']['url'] = key;

            // Update local attribute
            return $.ajax({
              type: 'POST',
              url: url,
              dataType: "application/json",
              data: formData,
              complete(result) { 
                let responseText = JSON.parse(result.responseText);
                if (responseText.status === 400) {
                  ToastCustom({title: 'Error', message: responseText.message, delay: 8000});
                } else {
                  Turbo.visit(window.location.href);
                }
              },
            });
          },
          fail: function(e, data) {
            progressBar.
              css("background", "red").
              text("Failed");
          }
        });
      });
    }


    // Remove subscription
    if ($('.remove-subscription').length !== 0) {
      $('.remove-subscription').click(function() {
        $(this).closest('.form-group').find('input[type=\'hidden\']').val('true');
        $(this).closest('.subscription-section').addClass('d-none');
      })
    }


  }
}